import { APP_INITIALIZER, NgModule } from '@angular/core';
import { ensureSession, UB_CLIENT } from '@unleashed/api/common';
import { AppComponent } from './app.component';
import { EcommerceModule } from '@unleashed/ecommerce/ecommerce.module';
import { environment } from 'src/environments/environment';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { NoopGoogleTagManagerService } from '@unleashed/services/common/noop-google-tag-manager.service';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    EcommerceModule
  ],
  providers: [
    { provide: UB_CLIENT, useValue: 'booking-pma' },
    { provide: APP_INITIALIZER, multi: true, useValue: () => ensureSession(environment.unleashedApiUrl, 'booking-pma') },
    {
      provide: GoogleTagManagerService,
      useClass: environment.production
        ? GoogleTagManagerService
        : NoopGoogleTagManagerService
    },
    ...(environment.production
      ? [{ provide: 'googleTagManagerId', useValue: environment.googleTagManager.id }]
      : [])
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
